import { localForageHelper } from '@/hub-shared'
import { useEffect, useState } from 'react'

export type ActionsAvailables = 'renew' | 'switch' | 'addAccount'

export interface ISocialState {
  socialHash?: string
  action?: ActionsAvailables
  idProfile?: string
  idCampaign?: string
  socialOpen?: boolean
  socialFormOpen?: boolean
}

export default (): [
  socialNetworkInformationActions: ISocialState,
  setSocialNetworkInformationActions: (newSocialNetworkInformationActions: ISocialState) => void
] => {
  const [socialNetworkInformationActions, setSocialNetworkInformationActions] = useState<ISocialState>(null)

  useEffect(() => {
    const { search } = window.location
    if (search === '') return
    const getActions = async () => {
      const actions: any = await localForageHelper.getItem('actions')

      const socialState: ISocialState = {}
      socialState.socialHash = search
      socialState.action = actions?.action as ActionsAvailables
      socialState.idProfile = actions?.idProfile
      socialState.idCampaign = actions?.idCampaign
      socialState.socialOpen = true
      socialState.socialFormOpen = false

      setSocialNetworkInformationActions(socialState)
    }

    getActions()
  }, [])

  return [socialNetworkInformationActions, setSocialNetworkInformationActions]
}
